import OrgAdmin from './OrgAdmin'

export default OrgAdmin
